if (window.__INITIAL_STATE__.glb) {
    window.__INITIAL_STATE__ = window.__INITIAL_STATE__.glb;
}

import { createCSR, createSSR } from './app.js';
import { fnExt } from '@/common/utilities/jqext';
import initialParse from '@/common/utilities/initialparse';
import initialClient from '@/common/utilities/initialclient';
import eventDrag from '@/common/utilities/jqext/event.drag';
import registerDirectives from '@/common/directives';
import { populateStoreForPageType } from './entry-common.js';
import windowPolyfill from '@/common/utilities/window.polyfill.js';

$.fn.extend(fnExt);
eventDrag($);
windowPolyfill(window);
async function mountApp() {
    if (window.__INITIAL_STATE__) {
        const context = initialParse(window.__INITIAL_STATE__);
        // see vweb/common/controllers/vuecontroller.js for where the context.ssr object is populated by the server
        const shouldHydrate = context?.ssr && context?.ssr?.useSSR && context?.ssr?.shouldHydrate;
        const { router, app, store } = shouldHydrate ? createSSR(null) : createCSR(null);

        initialClient(context);
        store.commit('glb/initalGlbState', context);
        registerDirectives(app);
        populateStoreForPageType(store, app);

        await router.isReady();
        app.mount('#app');
    }
}

mountApp();

export default mountApp;
